import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import Wavee from '../Wave/Wavee';
import { container, intro, details } from '../Pagevariants/Pagevariants';
import './Home.scss';

const Home = () => {
  const intros = "Hello, I'm Collins Musoko, a Full-Stack Developer";
  return (
    <motion.div
      id="home"
      className="app__home"
    >
      <div className="app__home-section">
        <motion.div
          className="app__home-profile"
        >
          <motion.img
            src={images.collins}
            alt="Collins profile"
            whileInView={{ scale: [0, 1], opacity: [0, 1] }}
            transition={{ duration: 1.5, ease: 'easeInOut' }}
          />
        </motion.div>
        <motion.div
          className="app__home-details"
          initial="initial"
          animate="animate"
          variants={container}
        >
          <motion.p
            variants={intro}
          >
            <span className="detail-intro">
              {intros}
            </span>
            <br />
            <br />
          </motion.p>
          <motion.h2
            variants={details}
          >
            <span className="detail-mid">
              I create web solutions
              <br />
              that leave a mark.
            </span>
            <br />
          </motion.h2>
          <br />
          <motion.p
            variants={intro}
          >
            <span className="detail-end">
              I&apos;m your trusted Frontend Engineer, Backend Engineer,
              <br />
              and a collaborative partner
            </span>
            <br />
            <br />
            <br />
            <br />
            <a className="detail-projects" href="#projects">View My Projects</a>
          </motion.p>
        </motion.div>
      </div>
      <Wavee />
    </motion.div>
  );
};

export default Home;
